export enum ConfirmationPopupType {
  DEFAULT = 'default',
  DELETE = 'delete',
}
